import React from 'react';
import { Tooltip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type StatusIconProps = {
    score?: number,
    hasFilledQuestionnaire?: boolean,
    isSharingScore?: boolean,
}

/**
 * Icon based on user comfort scores for an event format:
 * very sad, sad, neutral, happy, very happy, locked, or unknown
 */
export default class StatusIcon extends React.Component<StatusIconProps, {}> {
    lockIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle"/>
            <FontAwesomeIcon icon="lock" transform="shrink-7" color="#C993FF"/>
        </span>
    );
    
    verySadFaceIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle" color="#FF596C"/>
            <FontAwesomeIcon icon={["far", "frown-open"]}/>
        </span>
    );
    verySadUpperScore = 30;
    
    sadFaceIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle" color="#FFA945"/>
            <FontAwesomeIcon icon={["far", "frown"]}/>
        </span>
    );
    sadUpperScore = 45;
    
    neutralFaceIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle" color="#FFD600"/>
            <FontAwesomeIcon icon={["far", "meh"]}/>
        </span>
    );
    neutralUpperScore = 55;
    
    happyFaceIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle" color="#ADFF00"/>
            <FontAwesomeIcon icon={["far", "smile"]}/>
        </span>
    );
    happyUpperScore = 70;
    
    veryHappyFaceIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle" color="#43FFBB"/>
            <FontAwesomeIcon icon={["far", "grin"]}/>
        </span>
    );
    
    questionIcon = (
        <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="circle" color="white"/>
            <FontAwesomeIcon icon="question-circle"/>
        </span>
    );

    render() {
        // Initialize the icon container and tooltip text
        let iconContainer: JSX.Element | undefined;
        let tooltipText: string | undefined;

        // Set the icon container to render the correct face/icon based on the given score and privacy settings
        if (this.props.hasFilledQuestionnaire && this.props.isSharingScore === false) {
            // If the user is not sharing score data, show the lock icon
            iconContainer = this.lockIcon;
            tooltipText = "This user is not sharing comfort score data";
        } else {
            if (this.props.score && this.props.score >= 0) {
                // If a score was provided, return the correct face icon
                if (this.props.score < this.verySadUpperScore) {
                    iconContainer = this.verySadFaceIcon;
                    tooltipText = "Very uncomfortable";
                } else if (this.props.score < this.sadUpperScore) {
                    iconContainer = this.sadFaceIcon;
                    tooltipText = "Uncomfortable";
                } else if (this.props.score < this.neutralUpperScore) {
                    iconContainer = this.neutralFaceIcon;
                    tooltipText = "Neutral comfort level";
                } else if (this.props.score < this.happyUpperScore) {
                    iconContainer = this.happyFaceIcon;
                    tooltipText = "Comfortable";
                } else {
                    iconContainer = this.veryHappyFaceIcon;
                    tooltipText = "Very comfortable";
                }
            } else {
                // If a score was not provided, return a question mark icon
                iconContainer = this.questionIcon;
                tooltipText = "Unknown comfort level";
            }
        }

        return (
            <Tooltip title={tooltipText}>{iconContainer}</Tooltip>
        );
    }
}